module.exports = __webpack_public_path__ + "img/cardreserve.3e8afa23.png";